import { render, staticRenderFns } from "./Portal.vue?vue&type=template&id=669b1400&scoped=true"
import script from "./Portal.vue?vue&type=script&lang=js"
export * from "./Portal.vue?vue&type=script&lang=js"
import style0 from "./Portal.vue?vue&type=style&index=0&id=669b1400&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669b1400",
  null
  
)

export default component.exports